import { useCallback } from 'react';
import { useLoading } from '../components/LoadingContext';

export const useApiWithLoading = () => {
  const { withLoading, showLoading, hideLoading } = useLoading();

  const apiCall = useCallback(
    async (apiFunction) => {
      return withLoading(apiFunction);
    },
    [withLoading]
  );

  const apiCallWithCustomLoading = useCallback(
    async (apiFunction) => {
      try {
        showLoading();
        const result = await apiFunction();
        return result;
      } finally {
        hideLoading();
      }
    },
    [showLoading, hideLoading]
  );

  return {
    apiCall,
    apiCallWithCustomLoading,
  };
};
